import React from "react";
import { LANDSALE_LOGO, darkNotFound } from "../../assets";
import "./styles.css";

const ItemInventory = ({ inventory, onItemSelection }) => {
  return (
    <div className="column col-6 col-md-4 col-lg-2 col-xlg-2">
      {inventory.status == "PROCESSING" ? (
        <div
          className="resourceImg loading"
          onClick={() => {
            onItemSelection(inventory);
          }}
        >
          <div className="loadingState">
            <span className="loader"></span>
            <img src={darkNotFound} alt="not found" />
          </div>
          <p className="loading-txt">
            Please wait, <br /> your request is processing.
          </p>
        </div>
      ) : (
        <div
          className="resourceImg"
          onClick={() => {
            onItemSelection(inventory);
          }}
        >
          <img
            // src={
            //   inventory.image?.startsWith("http")
            //     ? inventory.image
            //     : LANDSALE_LOGO
            // }
            src={
              inventory?.plot_id
                ? process.env.REACT_APP_INVENTORY_IMAGES +
                  `${inventory?.size}/${inventory?.rarity}.jpg`
                : inventory?.id
                ? process.env.REACT_APP_INVENTORY_IMAGES + "empyrean_tower.jpg"
                : ""
            }
            className="img img-fluid"
            alt="land-sale"
          />
        </div>
      )}
    </div>
  );
};
export default ItemInventory;
